module.exports = __webpack_public_path__ + "img/1.c1aa31c4.png";